import React from "react";
import { Link } from "react-router-dom";
import Header from "../../components/LPHeader";
import Footer from "../../components/LPFooter";
import Image1 from "../../assets/images/mobile_collab_no_bg.png";
import { FaArrowRight } from "react-icons/fa";

const FAQ = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white font-inter">
      <Header />
      <main className="flex-grow mb-12 md:mb-24">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Hero Section: Changed from grid to responsive flex */}
          <div className="flex flex-col md:flex-row items-center gap-8 my-8 md:my-16">
            {/* ---Right Column (Text)--- */}
            <div className="w-full md:w-2/3 text-center md:text-left md:order-2">
              <h1 className="text-4xl sm:text-5xl lg:text-7xl font-semibold pb-4">
                Frequently
                <br className="hidden md:block" /> Asked Questions
              </h1>
              <p className="text-md sm:text-2xl lg:text-3xl">
                Clear answers, quick info.
                <br className="hidden md:block" /> We've got you covered.
              </p>
            </div>

            {/* ---Left Column (Image)--- */}
            <div className="w-full md:w-1/3 md:order-1">
              <img
                src={Image1}
                alt="Mobile Collaboration"
                className="w-3/4 md:w-full h-auto mx-auto"
              />
            </div>
          </div>

          {/* Q&A Sections with responsive text */}
          <div className="pt-3 pb-4">
            <h2 className="text-2xl md:text-4xl font-bold pb-4">
              Who can Join Scholarty?
            </h2>
            <p className="text-md md:text-2xl pb-4">
              <span className="font-bold">Any Student! </span>
              Whether you're a college student, a high school student preparing
              for college, or a club leader. Scholarty is for you.
            </p>
            <p className="text-md md:text-2xl pb-8">
              Join our growing academic network.
            </p>
            <hr />
          </div>
          <div className="pt-3 pb-4">
            <h2 className="text-2xl md:text-4xl font-bold pb-4">
              Is it free to join?
            </h2>
            <p className="text-md md:text-2xl pb-4">
              <span className="font-bold">Absolutely. </span>
              Signing up and using all core features is completely free for
              students and clubs.
            </p>
            <p className="text-md md:text-2xl pb-8">
              We're here to empower you, not charge you.
            </p>
            <hr />
          </div>
          <div className="pt-3 pb-4">
            <h2 className="text-2xl md:text-4xl font-bold pb-4">
              When does it launch?
            </h2>
            <p className="text-md md:text-2xl pb-4">
              <span className="font-bold">
                We're building for our students.{" "}
              </span>
              We're currently onboarding to go live with select universities and
              high schools.
            </p>
            <p className="text-md md:text-2xl pb-8">
              <Link to="/join-us" className="text-blue-600 hover:underline">
                Sign up
              </Link>{" "}
              for early access and be among the first to shape the future of
              campus life.
            </p>
            <hr />
          </div>
          <div className="pt-3 pb-3 md:pb-16 md:text-left">
            <h2 className="text-2xl md:text-4xl font-bold pb-4">
              Stay Curious
            </h2>
            <p className="text-md md:text-2xl pb-8 max-w-3xl md:text-left">
              Still have questions? Reach out anytime at{" "}
              <a
                className="text-blue-600 hover:underline"
                href="mailto:contact@scholarty.com"
              >
                contact@scholarty.com
              </a>{" "}
              or join the waitlist to get updates.
            </p>
            <Link
              to="/join-us"
              className="inline-block bg-[#5379F6] hover:bg-[#4A6ACB] text-white px-6 py-3 md:px-8 md:py-4 rounded-lg shadow-md transition duration-300 text-lg md:text-lg "
            >
              Join the Beta Test Waitlist{" "}
              <FaArrowRight className="ml-3 inline" />
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
export default FAQ;
